import Nullstack from 'nullstack';
export default function IconClearFormatting({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-clear-formatting",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M17 15l4 4m0 -4l-4 4"
  }), "   ", Nullstack.element("path", {
    d: "M7 6v-1h11v1"
  }), "   ", Nullstack.element("line", {
    x1: "7",
    y1: "19",
    x2: "11",
    y2: "19"
  }), "   ", Nullstack.element("line", {
    x1: "13",
    y1: "5",
    x2: "9",
    y2: "19"
  }), " ");
}